import React from 'react';
import styles from './MetricCard.module.css';

const MetricCard = ({
  label,
  value,
  subtext,
  isGreen = false,
  className = '',
  style = {}
}) => {
  return (
    <div style={style} className={`${styles.metricItem} ${className}`.trim()}>
      <div className={styles.label}>{label}</div>
      <div className={`${styles.value} ${isGreen ? styles.greenValue : ''}`.trim()}>
        {value}
      </div>
      {subtext && <div className={styles.subtext}>{subtext}</div>}
    </div>
  );
};

export default MetricCard;
